<template>
  <div class="page_wrapper">
    <div class="dis_flex dict_wrapper">
      <a-icon type="left-circle" class="btn_back" theme="twoTone" @click="$router.go(-1)" />
      <h2 class="title_from">{{ formTitle }}</h2>
    </div>

    <div class="data-form">
      <a-form-model ref="dataInfo" :model="dataInfo" :rules="rules">
        <div class="row_data">
          <a-form-model-item class="item_businessDis" colon label="所属区域" prop="districId">
            <a-select placeholder="请选择" v-model="dataInfo.districId">
              <a-select-option v-for="item in districtList" :key="item.areaId" :value="item.areaId">{{
                item.areaName
              }}</a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item class="item_businessDis" colon label="商圈名称" prop="businessDistrictName">
            <a-input :max-length="20" v-model="dataInfo.businessDistrictName" placeholder="请输入" />
          </a-form-model-item>

          <a-form-model-item class="item_businessDis " colon label="商圈首字母简称" prop="businessDistrictAcronym">
            <a-input class="uppercase_text" :max-length="4" v-model="dataInfo.businessDistrictAcronym" placeholder="用于房源编号" />
          </a-form-model-item>

          <a-form-model-item class="item_businessDis" colon label="是否主商圈" prop="isPrimaryBusinessDistrict">
            <a-select placeholder="请选择" v-model="dataInfo.isPrimaryBusinessDistrict">
              <a-select-option v-for="d in isOpts" :key="d.dictValue" :value="d.dictValue">{{
                d.dictLabel
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </div>
        <!-- <div class="row_data">
          <a-form-model-item class="item_businessDis" colon label="地图标注" prop="businessDistrictScope">
            <a-input-number v-model="dataInfo.businessDistrictScope" :default-value="100" :min="0" :max="100" @change="pointChange" />
          </a-form-model-item>
        </div> -->

        <a-form-model-item class="btn_opts">
          <a-button class="btn_opt" type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <!-- <a-button class="btn_opt" type="d" @click="goList">
            取消
          </a-button> -->
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import { sysList } from '@/api/setting/sys'
import { areaList } from '@/api/setting/area'
import {
  addBusinessDistrict,
  updateBusinessDistrict,
  // delBusinessDistrict,
  getBusinessDistrict
} from '@/api/setting/businessdistrict'

export default {
  name: 'BusinessDisSave',
  props: {},
  components: {},
  data () {
    return {
      submitLoading: false,
      formTitle: '新增商圈信息',

      queryDisParam: {
        districtFullName: undefined, // 区域全称
        districtShortName: undefined // 区域简称
      },
      districtList: [],
      loading: false,

      isOpts: [], // 是否
      districtOpts: [], // 区域

      // 表单参数
      dataInfo: {
        businessDistrictName: undefined, // 商圈名称
        businessDistrictScope: undefined, //	商圈范围
        districId: undefined, //	区域ID
        id: undefined, //	id，新增时不传，修改时必传
        isPrimaryBusinessDistrict: undefined, //	是否主商圈 字典表类型：sys_yes_no
        businessDistrictAcronym: undefined // 商圈首字母简称
      },
      keyId: undefined,
      rules: {
        businessDistrictName: [{ required: true, message: '必填', trigger: 'blur' }],
        // businessDistrictScope: [{ required: true, message: '必填', trigger: 'blur' }],(暂无)
        districId: [{ required: true, message: '必填', trigger: 'blur' }],
        businessDistrictAcronym: [{ required: true, message: '必填', trigger: 'blur' },
        { pattern: /^[a-zA-Z]+$/, message: '只含字母', trigger: 'blur' },
        {  min: 4, max: 4, message: '请填写四位的商圈首字母', trigger: 'blur'  }
        ],
        isPrimaryBusinessDistrict: [{ required: true, message: '必选', trigger: 'blur' }]
        // id: undefined,//新增时不传，修改时必传
      },
       queryArea: {
        areaName: undefined, //	名称
        level: 3, // 等级（1：省 2：市 3：区）
        parentId: undefined //	父类ID
      }
    }
  },
  filters: {},
  created () {
    // 是否
    this.getDicts('sys_yes_no').then((response) => {
      this.isOpts = response.data
    })

    this.reset()
    this.getDistrictList()

    let businessDisId = this.$route.query.dataId
    if (businessDisId !== '' && businessDisId != null && typeof businessDisId !== 'undefined') {
      businessDisId = parseInt(this.$route.query.dataId)
      this.dataInfo.keyId = businessDisId
      getBusinessDistrict(businessDisId).then((response) => {
        this.dataInfo = response.data
      })
      this.formTitle = '修改商圈信息'
    } else {
      this.formTitle = '新增商圈信息'
    }
     console.log(this.formTitle, this.dataInfo.id)
  },
  computed: {},
  watch: {},
  methods: {
    // 获取区域列表
    getDistrictList () {
      // this.loading = true
      // districtList(this.queryParam).then((response) => {
      //   if (response.code === 200) {
      //     const resData = response.data
      //     this.districtList = resData
      //   }
      //   this.loading = false
      // })
      this.getArea()
    },

     /** **根据系统信息查询区域信息***/
    getArea () {
      this.loading = true
      const param = { pageNum: 1, pageSize: 1 }
      sysList(param).then((response) => {
        if (response.code === 200) {
          const resData_ = response.data
          this.total = resData_.total
          if (this.total > 0) {
            this.list = resData_.records
            this.dataObj = resData_.records[0]
            this.sys = this.dataObj
            this.queryArea.parentId = this.sys.companyCityId
            areaList(this.queryArea).then((res) => {
              if (res.code === 200) {
                const resData = res.data
                const areaList = []
                if (resData != null && resData.length > 0) {
                  for (let i = 0; i < resData.length; i++) {
                    areaList.push({ areaId: resData[i].areaId, areaName: resData[i].areaName, children: [] })
                  }
                  this.districtList = areaList
                }
              }
              this.loading = false
            })
          } else {
            this.queryArea.parentId = ''
            this.$message.error('公司设置所在市信息获取失败')
          }
        }
        this.loading = false
      })
    },

    reset () {
      this.dataInfo = {
        businessDistrictName: undefined, // 商圈名称
        businessDistrictScope: undefined, //	商圈范围
        districId: undefined, //	区域ID
        id: undefined, //	id，新增时不传，修改时必传
        isPrimaryBusinessDistrict: undefined //	是否主商圈 字典表类型：sys_yes_no
      }
    },

    /** 提交按钮 */
    submitForm: function () {
      this.$refs.dataInfo.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          if (this.dataInfo.id !== undefined) {
            updateBusinessDistrict(this.dataInfo)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.goList()
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addBusinessDistrict(this.dataInfo)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.goList()
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
    pointChange (value) {
      console.log('changed', value)
    },

    goList () {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped>
.dict_wrapper,
.data-form {
  background: #fff;
  padding: 20px;
}
.data-form {
  margin-top: 10px;
}
.ml20 {
  margin-left: 20px;
}
.dis_flex {
  display: flex;
  align-items: center;
}
.title_from {
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 0px;
}
.row_data {
  display: flex;
  flex-wrap: wrap;
}

.item_businessDis {
  width: 280px;
  margin-right: 20px;
}
.btn_opt {
  margin-right: 50px;
}
.uppercase_text{
  text-transform:uppercase;
}
</style>
